//import styles from './OrderEngineComment.module.css'
import styles from '../CommonCss/OrderEngineCommon.module.css'
import main from './OrderEngineHistory.module.css'

import React, {useEffect, useRef, useState} from "react";
import useApiQuery from "../../../ApiQuery/UseApiQuery";
import ErrorLineItem, {ErrorLineItemRef} from "../../../FormTemplate/ErrorLineItem/ErrorLineItem";
import ModalWindow from "../../../FormTemplate/ModalWindow/ModalWindow";
import MainFormTemplate from "../../../FormTemplate/MainFormTemplate/MainFormTemplate";
import InputItem from "../../../FormTemplate/InputItem/InputItem";
import WaitLoader from "../../../WaitLoader/WaitLoader";

interface OrderEngineCommentPropsInt
{
    orderId:string
    onClose: ()=>void
    onSuccess?: ()=>void
}
interface IOrderHistory
{
    orderId:string
}
interface IHistoryItem
{
    source:string
    text: string
    tm: string
}

export default function OrderEngineHistory({orderId,onSuccess,onClose}:OrderEngineCommentPropsInt){
    const orderHistoryData = useRef<IOrderHistory>()
    const refState = useRef<ErrorLineItemRef>(null)
    const [ldrOrderHistory,rsOrderHistory,exOrderHistory] = useApiQuery("/sell/sim/order/history","post",orderHistoryData);

    const [history, setHistory] = useState<IHistoryItem[]>([])
    useEffect(()=>loadHistory(),[orderHistoryData])
    const loadHistory = ()=>{
        orderHistoryData.current ={
            orderId: orderId
        }
        exOrderHistory().then((e)=>{
            if(e?.success)
            {
                setHistory(e?.payload)
                return
            }
            if(refState.current)refState.current.show(e?.errorAsString ? e?.errorAsString :"Ошибка сервера",true,3000)
        })
    }


    const buildList = ()=>{

        const x = history?.map((item,idx)=>{
            const dt = new Date(item?.tm)

            const x = `${dt?.getDate().toString().padStart(2,'0')}.${(dt?.getMonth()+1).toString().padStart(2,'0')}.${dt?.getFullYear()} ${dt?.getHours().toString().padStart(2,'0')}:${dt?.getMinutes().toString().padStart(2,'0')}`
            return(
                <div key={idx} className={main.mainCont}>
                    <div className={main.cnt}>{idx+1}</div>
                    <div className={main.date}>{x}</div>
                    <div className={main.hsSrc}>{item?.source}</div>
                    <div>{item?.text}</div>
                </div>
            )


        })
        return x
    }


    return(
        <ModalWindow>
            <MainFormTemplate title={`История`} maxWidth={"800px"} background={"white"}>
                <div className={"row"}>
                   <div className={main.hsCont}>
                       {buildList()}

                   </div>
                </div>
                <ErrorLineItem ref={refState} ></ErrorLineItem>
                <div className={styles.actCont}>
                    <div className={styles.btnCont}>
                        <button type="button" className="btn btn-secondary "
                                onClick={(e)=>{
                                    onClose()
                                }}
                        >Закрыть</button>
                    </div>
                    <WaitLoader loading={ldrOrderHistory } api={rsOrderHistory} onlyLoading={true}>

                    </WaitLoader>

                </div>



            </MainFormTemplate>
        </ModalWindow>
    )
}